import { useSelector } from 'react-redux';
import { selectUserIsPremium } from 'redux/modules/auth';
import {
  getMonthlyReport,
  selectMonthlyReport,
  selectMonthlyReportError,
  selectMonthlyReportLoading,
} from 'redux/modules/monthlyReport';
import { useActions } from 'utils/useActions';

export const useConnect = () => {
  const report = useSelector(selectMonthlyReport);
  const loading = useSelector(selectMonthlyReportLoading);
  const error = useSelector(selectMonthlyReportError);
  const isPremium = useSelector(selectUserIsPremium);

  const actions = useActions({
    getReport: getMonthlyReport.request,
  });

  return {
    ...actions,
    error,
    isPremium,
    loading,
    report,
  };
};
